import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=a74421f0"
import script from "./NoData.vue?vue&type=script&lang=js"
export * from "./NoData.vue?vue&type=script&lang=js"
import style0 from "./NoData.vue?vue&type=style&index=0&id=a74421f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports